export const FUEL_SAVING_UPDATE_INPUT = 'FUEL_SAVING_UPDATE_INPUT';
export const FUEL_SAVING_RESET = 'FUEL_SAVING_RESET';
export const FUEL_SAVING_OPEN = 'FUEL_SAVING_OPEN';
export const FUEL_SAVING_APPLY = 'FUEL_SAVING_APPLY';
export const FUEL_SAVING_APPLY_AND_PRINT = 'FUEL_SAVING_APPLY_AND_PRINT';
export const FUEL_SAVING_CANCEL = 'FUEL_SAVING_CANCEL';
export const SET_VEHICLE_TABS = 'SET_VEHICLE_TABS';
export const SET_SCENARIO_LOAD_SETTLED = 'SET_SCENARIO_LOAD_SETTLED';
export const FETCH_FUEL_ECONOMY_REQUEST = 'FETCH_FUEL_ECONOMY_REQUEST';
export const FETCH_FUEL_ECONOMY_SUCCESS = 'FETCH_FUEL_ECONOMY_SUCCESS';
export const FETCH_FUEL_ECONOMY_FAILURE = 'FETCH_FUEL_ECONOMY_FAILURE';
